/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function (Flits, wishlistButton) {
    (wishlistButton = Flits.wishlistButton = function (options) {
        function wishListCollection() {
            if (Flits.request.page_type == "collection") {
                let collectionBtn = Flits(".flits-wishlist-colection");
                parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(collectionBtn).find(".flits-wls-count-btn").css("display", "flex"),
                    Flits(collectionBtn).show(),
                    Flits(".flits-wishlist-colection:not(.flits-template)").parent().attr("data-flits", "wishlist-collection-parent");
            }
        }
        function wishListDomReady() {
            Flits.checkAndSetupWishlistDiv();
        }
        function wishlistLocalData() {
            var wishlitsLocalHandles = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
            if (wishlitsLocalHandles) {
                var wishlitsLocalHandlesArray = wishlitsLocalHandles.split(",");
                console.log(wishlitsLocalHandlesArray.length);
                for (var i = 0; i < wishlitsLocalHandlesArray.length; i++) {
                    var s = Flits("*[data-flits-product-handle='" + wishlitsLocalHandlesArray[i] + "']");
                    s.animateWishlistButton(-1, Flits.t("Flits.locals.wishlisted_product_page.remove_from_wishlist_button", "Remove from Wishlist"));
                }
            }
        }
        function diff_minutes(dt1, dt2) {
            if (dt1 == undefined || dt2 == undefined) return 0;
            else {
                var diff = (dt2.getTime() - dt1.getTime()) / 1000;
                return (diff /= 60), Math.abs(Math.round(diff));
            }
        }
        Flits.wishlistButton.settings = {};
        var settings = {
            automaticAppendDivFunction: function () {},
            isWishlistAutomatic: 1,
            wslBtnType: 1,
            isCountEnable: 0,
            addtocartSelectors: ["form[action='/cart/add']"],
            wishListBtnDomSelector: "flits-wishlist-dom",
            wishlist_base_url: "/wishlist",
            add_wsl_url: "/add_to_wishlist",
            remove_wsl_url: "/remove_from_wishlist",
            wishlistHandle: "flits_wishlist_products",
            wishlistLastUpdate: "last_wishlist_product_update",
            clicked_add_button: "",
            appearance_style: {
                before_heart_clr: "#000000",
                before_btn_clr: "#fff",
                before_text_clr: "#f5020f",
                before_border_clr: "#000000",
                after_heart_clr: "#fc0303",
                after_btn_clr: "#080707",
                after_text_clr: "#f5faf9",
                after_border_clr: "#f7f5fa",
                collection_before_heart_clr: "#000000",
                collection_after_heart_clr: "#fc0303",
            },
        };
        (settings = Flits.extend(Flits.wishlistButton.settings, settings, options)),
            Flits.dispatchEvent("Flits:wishlistButton:Loaded", { settings: settings }),
            Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistLastUpdate) == undefined && Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistLastUpdate, new Date()),
            document.documentElement.style.setProperty("--primaryTingleButtonBGColor", 'rgb(16, 127, 168)'),
            document.documentElement.style.setProperty("--primaryTingleButtonHoverBGColor", 'rgb(16, 127, 168)'),
            document.documentElement.style.setProperty("--primaryTingleButtonTextColor", 'rgb(255, 255, 255)'),
            document.documentElement.style.setProperty("--secondaryTingleButtonBGColor", 'rgb(16, 127, 168)'),
            document.documentElement.style.setProperty("--secondaryTingleButtonTextColor", 'rgb(16, 127, 168)'),
            Flits.dispatchEvent("Flits:wishlistButtonColor:Loaded");
        let product_style_string =
            ".filts-wishlist-product-style .flits-wls-button-secondary," +
            ".filts-wishlist-product-style .flits-wls-button-secondary:visited{ " +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.before_text_clr +
            " !important;" +
            "border-color: " +
            Flits.wishlistButton.settings.appearance_style.before_border_clr +
            " !important;" +
            "background: " +
            Flits.wishlistButton.settings.appearance_style.before_btn_clr +
            " !important;" +
            "}" +
            ".filts-wishlist-product-style .flits-wls-button-secondary .flits-wls-icon-svg-color-blue { " +
            "fill: " +
            Flits.wishlistButton.settings.appearance_style.before_heart_clr +
            " !important;" +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.before_heart_clr +
            " !important;" +
            "}" +
            ".filts-wishlist-product-style .flits-wls-button-secondary.flits-wls-active," +
            ".filts-wishlist-product-style .flits-wls-button-secondary.flits-wls-active:visited{ " +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.after_text_clr +
            " !important;" +
            "border-color: " +
            Flits.wishlistButton.settings.appearance_style.after_border_clr +
            " !important;" +
            "background: " +
            Flits.wishlistButton.settings.appearance_style.after_btn_clr +
            " !important;" +
            "}" +
            ".filts-wishlist-product-style .flits-wls-button-secondary.flits-wls-active .flits-wls-icon-svg-color-blue { " +
            "fill: " +
            Flits.wishlistButton.settings.appearance_style.after_heart_clr +
            " !important;" +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.after_heart_clr +
            " !important;" +
            "}";
        let collection_style_string =
            ".flits-wishlist-colection-style .flits-wls-button-secondary .flits-wls-icon-svg-color-blue { " +
            "fill: " +
            Flits.wishlistButton.settings.appearance_style.collection_before_heart_clr +
            " !important;" +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.collection_before_heart_clr +
            " !important;" +
            "}" +
            ".flits-wishlist-colection-style .flits-wls-button-secondary.flits-wls-active .flits-wls-icon-svg-color-blue { " +
            "fill: " +
            Flits.wishlistButton.settings.appearance_style.collection_after_heart_clr +
            " !important;" +
            "color: " +
            Flits.wishlistButton.settings.appearance_style.collection_after_heart_clr +
            " !important;" +
            "}";
        Flits.styleCreate(product_style_string), Flits.styleCreate(collection_style_string);
        var modal = new flits_tingle.modal({
            footer: !1,
            stickyFooter: !1,
            getContent: !0,
            closeMethods: ["button"],
            closeLabel: "Close",
            beforeClose: function () {
                return !0;
                return !1;
            },
        });
        var modal_content = Flits("#flits-wsl-guest-modal").html();
        if (
            (modal.setContent(modal_content),
            Flits("#flits-wsl-guest-modal").remove(),
            Flits(document).on("submit", "#flits-guest-wsl-form", function (event) {
                event.preventDefault();
                let flits_customer_email = Flits("#flits_email_id").val();
                if (flits_customer_email === void 0 || flits_customer_email == null || flits_customer_email == "") return !1;
                Flits.setLocalStorage(Flits.cemail, flits_customer_email), Flits("#flits-guest-wsl-form").css({ display: "none" });
                let email_text = Flits("#flits-guest-email").html();
                Flits("#flits-guest-email").html(email_text.replace("{{ customer_email }}", "<strong>" + flits_customer_email + "</strong>")),
                    Flits("#flits-wsl-msg-modal").css({ display: "block" }),
                    Flits.wishlistButton.settings.clicked_add_button.click();
            }),
            Flits(document).on("click", ".flits-wls-button", function (event) {
                event.preventDefault(), event.stopPropagation(), event.stopImmediatePropagation();
                var el = Flits(this);
                Flits.wishlistButton.settings.clicked_add_button = el;
                var is_add;
                Flits(el).hasClass("flits-wls-inactive") ? (is_add = !0) : (is_add = !1);
                let customer_id = Flits(el).attr("data-flits-customer-id");
                let customer_email = Flits(el).attr("data-flits-customer-email");
                let product_id = Flits(el).attr("data-flits-product-id");
                let product_handle = Flits(el).attr("data-flits-product-handle");
                let product_title = Flits(el).attr("data-flits-product-title");
                let product_image = Flits(el).attr("data-flits-product-image");
                let count = 0;
                let wsl_product_count = 0;
                let token = Flits.token;
                let add_url = Flits.base_url + Flits.wishlistButton.settings.wishlist_base_url + Flits.wishlistButton.settings.add_wsl_url;
                let remove_url = Flits.base_url + Flits.wishlistButton.settings.wishlist_base_url + Flits.wishlistButton.settings.remove_wsl_url;
              	let el_button = Flits("[data-flits-product-handle='" + product_handle + "']");
                if (Flits.isNull(customer_email)) {
                    let customer_email_cookie = Flits.getLocalStorage(Flits.cemail);
                    if (is_add)
                        if (Flits.isNull(customer_email_cookie)) return modal.open(), !1;
                        else customer_email = customer_email_cookie;
                    else customer_email = customer_email_cookie;
                }
                Flits(el).parent().find(".flits-wls-count-btn") && (count = Flits(el).parent().find(".flits-wls-count-btn").text()),
                    is_add
                        ? ((wsl_product_count = parseInt(count) + 1), Flits(el_button).animateWishlistButton(wsl_product_count, Flits.t("Flits.locals.wishlisted_product_page.remove_from_wishlist_button", "Remove from Wishlist")))
                        : ((wsl_product_count = parseInt(count) - 1), Flits(el_button).animateWishlistButton(wsl_product_count, Flits.t("Flits.locals.wishlisted_product_page.add_to_wishlist_button", "Add to Wishlist")));
                let params = {
                    customer_hash:Flits.customerHash,token:token,
                    customer_id: customer_id,
                    customer_email: customer_email,
                    product_id: product_id,
                    product_handle: product_handle,
                    product_title: product_title,
                    product_image: product_image,
                    wsl_product_count: wsl_product_count,
                };
                is_add
                    ? Flits.ajax({ type: "POST", url: add_url, data: params, contentType: "application/x-www-form-urlencoded" })
                          .done(function (resp) {
                              Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistHandle, resp.products_handle),
                                  flitsSnackbar.show({
                                      text:
                                          '<div class="flits-wls-snackbar">' +
                                          '<div class="flits-wls-snackbar-header">' +
                                          Flits.t("Flits.locals.wishlisted_product_page.product_added_to_wishlist", "Product has been added to your wishlist") +
                                          "</div>" +
                                          '<div class="flits-wls-snackbar-body">' +
                                          '<div class="flits-wls-snackbar-product-img" style="background-image: url(' +
                                          product_image +
                                          ')"></div>' +
                                          '<a class="flits-wls-snackbar-product-name">' +
                                          product_title +
                                          "</a></div> </div>",
                                      pos: "bottom-center",
                                      showAction: !1,
                                      customClass: "flits-cs-flits-snackbar-container",
                                  });
                          })
                          .fail(function (resp) {
                              Flits(el_button).animateWishlistButton(wsl_product_count - 1, Flits.t("Flits.locals.wishlisted_product_page.add_to_wishlist_button", "Add to Wishlist"));
                          })
                          .always(function () {})
                    : Flits.ajax({ type: "DELETE", url: remove_url, data: params, contentType: "application/x-www-form-urlencoded" })
                          .done(function (resp) {
                              Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistHandle, resp.products_handle),
                                  flitsSnackbar.show({
                                      text: "<p>" + Flits.t("Flits.locals.wishlisted_product_page.product_remove_from_wishlist", "Product removed from your wishlist") + "</p>",
                                      pos: "bottom-center",
                                      showAction: !1,
                                      customClass: "flits-alert-default",
                                  });
                          })
                          .fail(function (resp) {
                              Flits(el_button).animateWishlistButton(wsl_product_count + 1, Flits.t("Flits.locals.wishlisted_product_page.remove_from_wishlist_button", "Remove from Wishlist"));
                          })
                          .always(function () {});
                return;
            }),
            Flits.customer_id)
        ) {
            let params = { customer_id: Flits.customer_id, customer_hash:Flits.customerHash,token:Flits.token };
            let dt1 = new Date(Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistLastUpdate));
            let dt2 = new Date();
            diff_minutes(dt1, dt2) >= 5
                ? Flits.ajax({ type: "GET", url: Flits.base_url + Flits.wishlistButton.settings.wishlist_base_url, data: params })
                      .done(function (resp) {
                          Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistHandle, "");
                          let productHandle = [];
                          for (let i = 0; i < resp.data.length; i++) productHandle.push(resp.data[i].product_handle);
                          (productHandle = productHandle.join(",")),
                              Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistHandle, productHandle),
                              Flits.setLocalStorage(Flits.wishlistButton.settings.wishlistLastUpdate, new Date()),
                              Flits.request.page_type != "customers/account" && wishlistLocalData();
                      })
                      .fail(function (resp) {})
                      .always(function () {})
                : Flits.request.page_type != "customers/account" && wishlistLocalData();
        } else Flits.request.page_type != "customers/account" && wishlistLocalData();
        wishListDomReady(), wishListCollection();
    }),
        Flits.fn.extend({
            addWishlistBtn: function (attribute_data, domBtnSelector) {
                var settings = Flits.wishlistButton.settings;
                var domBtnSelector = domBtnSelector || Flits.wishlistButton.settings.wishListBtnDomSelector;
                return (
                    this.filter(':not([data-flits="wishlist-btn-added"])').each(function (index, el) {
                        if (((el = Flits(el)), el.css("display") != "none" && el.css("visibility") != "hidden")) {
                            if (typeof el[0].addEventListener != "function") return;
                            var parent = el.parent();
                            var cloneNode = Flits("#" + domBtnSelector).clone();
                            Flits(cloneNode).removeClass("flits-template"),
                                Flits(cloneNode).css("display", "flex"),
                                Flits(cloneNode).removeAttr("id"),
                                attribute_data &&
                                    (Flits(cloneNode).find(".flits-wls-button").attr(attribute_data),
                                    attribute_data["data-flits-product-handle"] &&
                                        Flits.isProductAddedInWishlist(attribute_data["data-flits-product-handle"]) &&
                                        Flits(cloneNode).find(".flits-wls-button").animateWishlistButton(-1, Flits.t("Flits.locals.wishlisted_product_page.remove_from_wishlist_button", "Remove from Wishlist"))),
                                Flits.wishlistButton.settings.wslBtnType != -1 && Flits(cloneNode).find(".flits-wls-icon-with-text-text").css("display", "block"),
                                parseInt(Flits.wishlistButton.settings.isCountEnable) && Flits(cloneNode).find(".flits-wls-count-btn").css("display", "flex"),
                                el.after(cloneNode),
                                el.attr("data-flits", "wishlist-btn-added"),
                                parent.attr("data-flits", "wishlist-btn-parent"),
                                settings.automaticAppendDivFunction.apply(this, [el, parent, cloneNode]),
                                Flits.dispatchEvent("Flits:WishlistAutomaticCode:Loaded", { el: el, parent: parent, cloneNode: cloneNode });
                        }
                    }),
                    this
                );
            },
            animateWishlistButton: function (c, title_txt) {
                return (
                    Flits.each(this, function (index, v) {
                        Flits(v).attr("data-tippy-content", title_txt),
                            Flits(v).find(".flits-wls-icon-with-text-text") && Flits(v).find(".flits-wls-icon-with-text-text").text(title_txt),
                            c != -1 && Flits(v).parent().find(".flits-wls-count-btn") && Flits(v).parent().find(".flits-wls-count-btn").text(c),
                            Flits(v).hasClass("flits-wls-deactivate") && Flits(v).removeClass("flits-wls-deactivate"),
                            Flits(v).hasClass("flits-wls-active") && Flits(v).addClass("flits-wls-deactivate"),
                            Flits(v).toggleClass("flits-wls-animate"),
                            Flits(v).toggleClass("flits-wls-active"),
                            Flits(v).toggleClass("flits-wls-inactive");
                    }),
                    this
                );
            },
        }),
        Flits.extend({
            isProductAddedInWishlist: function (handle) {
                var wishlitsLocalHandles = Flits.getLocalStorage(Flits.wishlistButton.settings.wishlistHandle);
                return Flits.isNull(wishlitsLocalHandles) ? !1 : wishlitsLocalHandles.split(",").indexOf(handle) != -1 ? !0 : !1;
            },
            checkAndSetupWishlistDiv: function () {
                Flits.wishlistButton.settings.isWishlistAutomatic == 1
                    ? Flits(Flits.wishlistButton.settings.addtocartSelectors.join(",")).addWishlistBtn()
                    : (Flits.wishlistButton.settings.wslBtnType != -1 &&
                          Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                              .not(".flits-template")
                              .find(".flits-wls-icon-with-text-text")
                              .css("display", "block"),
                      parseInt(Flits.wishlistButton.settings.isCountEnable) &&
                          Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                              .not(".flits-template")
                              .find(".flits-wls-count-btn")
                              .css("display", "flex"),
                      Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                          .not(".flits-template")
                          .parent()
                          .find(Flits.wishlistButton.settings.addtocartSelectors.join(","))
                          .attr("data-flits", "wishlist-btn-added"),
                      Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                          .not(".flits-template")
                          .parent()
                          .find(Flits.wishlistButton.settings.addtocartSelectors.join(","))
                          .parent()
                          .attr("data-flits", "wishlist-btn-parent"),
                      Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                          .not(".flits-template")
                          .css("display", "flex"),
                      Flits("#" + Flits.wishlistButton.settings.wishListBtnDomSelector)
                          .not(".flits-template")
                          .removeAttr("id"));
            },
        }),
        Flits.Metafields.IS_WISHLIST_ENABLE == 1 &&
            Flits.wishlistButton({
                isWishlistAutomatic: Flits.Metafields.WSL_CODE_AUTOMATIC,
                wslBtnType: Flits.Metafields.WSL_BTN_TYPE,
                isCountEnable: Flits.Metafields.WSL_COUNT_ENABLE,
                appearance_style: {
                    before_heart_clr: Flits.Metafields.WSL_BEFORE_HEART_COLOR,
                    before_btn_clr: Flits.Metafields.WSL_BEFORE_BTN_COLOR,
                    before_text_clr: Flits.Metafields.WSL_BEFORE_BTN_TEXT_COLOR,
                    before_border_clr: Flits.Metafields.WSL_BEFORE_BTN_BORDER_COLOR,
                    after_heart_clr: Flits.Metafields.WSL_AFTER_HEART_COLOR,
                    after_btn_clr: Flits.Metafields.WSL_AFTER_BTN_COLOR,
                    after_text_clr: Flits.Metafields.WSL_AFTER_BTN_TEXT_COLOR,
                    after_border_clr: Flits.Metafields.WSL_AFTER_BTN_BORDER_COLOR,
                    collection_before_heart_clr: Flits.Metafields.WSL_DEFAULT_BEFORE_HEART_COLOR,
                    collection_after_heart_clr: Flits.Metafields.WSL_DEFAULT_AFTER_HEART_COLOR,
                },
            });
})(Flits);
